import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CommonComponentsModule } from '@app/components/common-components.module';
import { DirectivesModule } from '@app/components/directives/directives.module';
import { KeyPadModule } from '@app/components/key-pad-module/key-pad-module';
import { SharedModule } from '@app/shared/shared.module';

import { CoreModalModule } from '../core-modal/core-modal.module';
import { FormCommonModule } from '../form-common/form-common.module';
import { ModalComponentsCommonModule } from '../modal-components-common/modal-components-common.module';
import { AlertComponent } from './components';
import { ConfirmComponent } from './components/root-modal-components/confirm/confirm.component';
import {
  ItemCountValidationModalComponent,
} from './components/root-modal-components/item-count-validation/item-count-validation-modal.component';
import { RootModalService } from './services/root-modal-service/root-modal.service';

const MODALS = [
  AlertComponent,
  ConfirmComponent,
  ItemCountValidationModalComponent,
];

@NgModule({
  imports: [
    CommonComponentsModule,
    CommonModule,
    CoreModalModule,
    DirectivesModule,
    FormsModule,
    FormCommonModule,
    KeyPadModule,
    ModalComponentsCommonModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    DirectivesModule,
  ],
  exports: [ModalComponentsCommonModule, TranslateModule],
  declarations: MODALS,
  providers: [RootModalService],
})
export class ModalModule {}
